import { render, staticRenderFns } from "./SopBlockEntryStep.vue?vue&type=template&id=f608c944&scoped=true&"
import script from "./SopBlockEntryStep.vue?vue&type=script&lang=ts&"
export * from "./SopBlockEntryStep.vue?vue&type=script&lang=ts&"
import style0 from "./SopBlockEntryStep.vue?vue&type=style&index=0&id=f608c944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f608c944",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})
